<template>
  <div class="text-center">
    <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" max-width="1000" v-model="dialog" scrollable>
      <v-card>
        <v-card-title class="primary white--text">
          THÊM HỌC SINH VÀO LỚP <v-spacer></v-spacer>
          <v-btn dark icon>
            <v-icon @click="cancel">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-card outlined class="pa-4 my-4 elevation-0">
            <v-row>
              <v-col cols="12" md="10">
                <v-row>
                  <v-col cols="12" md="6" class="pb-0">
                    <AutocompleteClass
                      v-model="currentClass"
                      clear-icon="mdi-close"
                      placeholder="Lớp"
                      outlined
                      dense
                      large
                      deletable-chips
                      hide-details
                      :filter="classFilter"
                    />
                  </v-col>
                  <v-col cols="12" md="6" class="pb-0">
                    <AutocompleteStudent
                      :syncedValue.sync="student"
                      clearable
                      clear-icon="mdi-close"
                      outlined
                      label="Học sinh"
                      dense
                      deletable-chips
                      hide-details
                      :filter="studentFilter"
                      @change="studentChanged"
                    />
                  </v-col>
                  <v-col cols="4" class="pb-0"> </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="2">
                <v-btn class="search-button" color="#0D47A1" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
              </v-col>
            </v-row>
          </v-card>

          <!-- table -->
          <v-card outlined class="my-4 elevation-0">
            <StudentDataTable
              showSelect
              ref="studentDataTable"
              :propHeaders="headers"
              :filter="filter"
              :selected.sync="selecteds"
            />
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="d-flex justify-space-between align-center" style="width: 100%">
            <v-btn color="gray" class="ma-2 px-8" @click="cancel" outlined>Hủy</v-btn>
            <div>
              Đã chọn {{ selecteds.length }} học sinh
              <v-btn color="primary" class="elevation-0 px-8 mx-2" @click="save">Thêm</v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { get } from 'lodash'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass'
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
import StudentDataTable from '@/modules/student/StudentDataTable.vue'

export default {
  components: {
    AutocompleteClass,
    AutocompleteStudent,
    StudentDataTable,
  },
  props: {
    state: Boolean,
  },
  data() {
    return {
      currentClass: null,
      student: null,
      dialog: false,
      selecteds: [],
      headers: null,
    }
  },
  created() {
    this.headers = [
      {
        text: 'Tên học sinh',
        value: 'name',
        align: 'left',
        sortable: false,
        show: true,
      },
      {
        text: 'Ngày sinh',
        value: 'dob',
        align: 'left',
        sortable: false,
        show: true,
      },
      {
        text: 'Lớp',
        value: 'currentClass',
        align: 'left',
        sortable: false,
        show: true,
        width: '100',
      },
    ]
  },

  computed: {
    ...mapGetters('classDetail', ['classData']),
    classFilter() {
      return { grade: get(this.classData, 'grade.id') }
    },
    studentFilter() {
      return { currentClass: get(this.currentClass, 'id') }
    },
    filter() {
      return { grade: get(this.classData, 'grade.id'), id_nin: [...this.classData.students.map((s) => s.id)] }
    },
  },
  methods: {
    ...mapActions('classDetail', ['updateClass']),
    cancel() {
      this.dialog = false
    },
    studentChanged() {
      this.currentClass = get(this.student, 'currentClass')
    },
    onFilterChanged() {
      const params = {
        grade: get(this.classData, 'grade.id'),
        currentClass: get(this.currentClass, 'id'),
        id: get(this.student, 'id'),
      }
      this.$refs.studentDataTable.refresh(params)
    },
    save() {
      this.$dialog.confirm({
        title: 'Thêm học sinh',
        text: ` Bạn có Chắc Chắn muốn thêm ${this.selecteds.length} học sinh vào lớp ?`,
        okText: 'OK',
        cancelText: 'Hủy',
        done: async () => {
          try {
            await this.updateClass({
              id: this.classData.id,
              students: [...this.classData.students, ...this.selecteds],
            })
            this.$alert.addSuccess()
            this.dialog = false
          } catch (error) {
            this.$alert.addError()
          }
        },
      })
    },
  },
  watch: {
    state(state) {
      this.dialog = true
    },
  },
}
</script>

<style scoped></style>
